import React from "react";
import "./DropDownButtons.css";
import { FaUserTie, FaBookmark, FaStore, FaCog, FaSignOutAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { getAuth, signOut } from "firebase/auth";

const DropDownButtons = () => {
    const navigate = useNavigate();
  return (
    <div className="dropdown-buttons">
      <button className="dropdown-btn" onClick={() => navigate('/myprofile')}>
        <FaUserTie className="icon green" />
        <span>Profile</span>
      </button>

      <button className="dropdown-btn" onClick={() => navigate('/bookmarks')}>
        <FaBookmark className="icon green" />
        <span>Bookmarks</span>
      </button>

      <button className="dropdown-btn" onClick={() => navigate('/seller')}>
        <FaStore className="icon green" />
        <span>Seller</span>
      </button>

      <button className="dropdown-btn" onClick={() => navigate('/settings')}>
        <FaCog className="icon green" />
        <span>Settings</span>
      </button>

      <button 
        className="dropdown-btn" 
        onClick={async () => {
          const auth = getAuth();
          await signOut(auth);
          navigate('/signin');
        }}
      >
        <FaSignOutAlt className="icon green" />
        <span>Sign Out</span>
      </button>
    </div>
  );
};

export default DropDownButtons;
